export function programCustomSelect() {
  const block = document.querySelector(".sbm-program-tabs-block");
  if (!block) return;

  const selectListFolders = block.querySelectorAll(".custom-select");

  selectListFolders.forEach((selectListFolder) => {
    selectDivClickHandler();

    function selectDivClickHandler() {
      const selectDiv = selectListFolder.querySelector(
        ".custom-select__selected"
      );
      const selectItems = selectListFolder.querySelectorAll(
        ".custom-select__item"
      );

      selectDiv.addEventListener("click", function () {
        this.classList.toggle("active");
      });

      // global select list reset if click outside
      document.addEventListener("click", (event) => {
        respondMouseClick(event);
      });
      function respondMouseClick(event) {
        if (
          event.target != selectDiv &&
          checkItemsTarget(event.target) != true
        ) {
          resetMouseClick();
        }
      }
      function checkItemsTarget(target) {
        let result = false;
        selectItems.forEach((item) => {
          if (item == target) result = true;
        });
        return result;
      }
      function resetMouseClick() {
        selectDiv.classList.remove("active");
      }
    }
  });
}
